import { render, staticRenderFns } from "./on.vue?vue&type=template&id=32e8adb8&"
import script from "./on.vue?vue&type=script&lang=js&"
export * from "./on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e8adb8')) {
      api.createRecord('32e8adb8', component.options)
    } else {
      api.reload('32e8adb8', component.options)
    }
    module.hot.accept("./on.vue?vue&type=template&id=32e8adb8&", function () {
      api.rerender('32e8adb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/page-cache/on.vue"
export default component.exports